import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { serverLogout } from '../utils/auth';

/**
 * LogoutPage - Gère la déconnexion de l'utilisateur
 * Révoque la session côté serveur, nettoie le localStorage et redirige vers /login
 */
const LogoutPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      // Révocation réelle côté serveur (puis purge locale)
      await serverLogout();
      localStorage.removeItem('authToken');
      localStorage.removeItem('favoriteProperties');
      navigate('/login', { replace: true });
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-slate-600">Déconnexion en cours...</p>
      </div>
    </div>
  );
};

export default LogoutPage;
